<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-1 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.RecepientPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.RecepientName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="ReceipentMember">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{ReceipentMember.MemberDisplayName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">
                
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientAgeYears}},{{SelectedpatientDetails.RecepientFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-2 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-6  padding-right-0px">
            <!--<div class="row font-size-12px">
    <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
    </div>:
    <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
    </div>
  </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="EmbryoTransferData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransferData2.ActivityStatus}}</label>
              </div>
            </div>
         
            <!--<div class="row">
    <div class="col-md-1 margin-left-auto padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
      </div>
    <div class="col-md-1 padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
    </div>

     <div class="col-md-1 padding-left-7px">

      <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
    </div>

  </div>-->
            <div class="row margin-right-0px" hidden>
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">
       
          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Embryo Transfer
                </label>
              </div>
              <div class="col-md-5  padding-right-0px padding-left-0px" *ngIf="GradingModel &&  SelectedpatientDetails">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right" *ngIf="GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                  <div class="col-md-11 margin-top-3px padding-left-0px padding-right-0px" *ngIf="EmbryoTransferData2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                  </div>

                  <div class="col-md-1" >
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransfer()" hidden>
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>
                </div>

                <div class="row float-right" *ngIf="EmbryoTransferData2">
                  <div class="col-md-11 margin-top-3px padding-left-0px padding-right-0px" >
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                  </div>

                  <div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransferdroplet()" hidden>
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>
                </div>
              
              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">
            <div class="card-body" *ngIf="GradingModel">
             
              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample5">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                    name="upload" >
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                  <div class="table-component table-tests">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tbody class="table-body">

                                          <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                            <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                            <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                            <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                              <div class="height-16px">
                                                <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                              </div>
                                            </td>
                                            <td class="padding-top-4px padding-bottom-4px">
                                              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                              <div class="test-icons float-right">
                                                <a (click)="delTEST(l)" title="Remove" ><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                </a>
                                              </div>
                                            </td>




                                          </tr>

                                        </tbody>
                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample6">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload" >
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                              <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                <div class="table-component">
                                  <div class="table-responsive">


                                    <table class="table table-striped margin-left-zero width-50-new">
                                      <!--<thead>
                                                              <tr>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                </th>

                                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>


                                                                <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                </th>











                                                              </tr>
                                                            </thead>-->
                                      <tbody class="table-body">

                                        <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                          <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                          <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                <div class="height-16px" >
                                  <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                </div>

                              </td>-->
                                          <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                          <td class="padding-top-4px padding-bottom-4px ">
                                            <div class="test-icons float-right">
                                              <a (click)="delMedicine(l)" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                              <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" >
                                                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                              </a>
                                            </div>
                                          </td>
                                          <!--<td class="padding-top-4px padding-bottom-4px">


                              </td>-->




                                        </tr>

                                      </tbody>
                                    </table>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              
              
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
